import React, { useState, useEffect } from "react";
import { Table, Select, Input, Button, Form } from "antd";
import QueueAnim from "rc-queue-anim";
import { SearchOutlined } from "@ant-design/icons";
import "./index.less";
import ajax from "../../utils/ajax";

// 导入图片资源
import hotPositionImg from "../../public/images/hot-position.png";

const Option = Select.Option;

const JobTable = (props) => {
  const [form] = Form.useForm();
  const [page, setPage] = useState({
    dataSource: [],
    total: 0,
    current: 0,
  });
  const [dqs, setDqs] = useState([]);
  const [depts, setDepts] = useState([]);

  const { columns, ecompIds, pageSize } = props;

  const loadJobs = (payload = {}) => {
    let baseInfo = {
      ecompIds,
      pageSize,
      curPage: page.current,
      ...payload,
    };
    ajax
      .post(
        "https://api-c.liepin.com/api/com.liepin.comp.c.get-so-jobs-by-comp-id",
        baseInfo
      )
      .then(({ flag, data }) => {
        if (flag === 1) {
          const { list, totalCount } = data;
          setPage({
            dataSource: list,
            total: totalCount,
            current: baseInfo.curPage,
          });
        }
      });
  };

  const loadDqs = () => {
    ajax
      .post(
        "https://api-c.liepin.com/api/com.liepin.comp.c.get-dqs-by-comp-id",
        { compId: ecompIds }
      )
      .then(({ flag, data }) => {
        if (flag === 1) {
          if (typeof data === "object") {
            let dqs = [];
            for (let key in data) {
              dqs.push({
                value: key,
                label: data[key],
              });
            }
            setDqs(dqs);
          }
        }
      });
  };

  const loadDepts = () => {
    ajax
      .post(
        "https://api-c.liepin.com/api/com.liepin.comp.c.get-depts-by-comp-id",
        { compId: ecompIds }
      )
      .then(({ flag, data }) => {
        if (flag === 1) {
          if (typeof data === "object") {
            let depts = [];
            for (let key in data) {
              depts.push({
                value: key,
                label: data[key],
              });
            }
            setDepts(depts);
          }
        }
      });
  };

  const handleSubmit = (value) => {
    loadJobs({ ...formatData(value), curPage: 0 });
  };

  const formatData = (data) => {
    for (let key in data) {
      if (data[key] === undefined || data[key] === "") {
        delete data[key];
      }
    }
    return data;
  };

  const handlePageChange = (page) => {
    loadJobs({ curPage: page - 1, ...formatData(form.getFieldsValue()) });
  };

  useEffect(() => {
    loadJobs();
    loadDqs();
    loadDepts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="_jobtable">
      <QueueAnim delay={200}>
        <div key="qa1" className="_jobtitle">
          <img src={hotPositionImg} alt="" />
        </div>
        <Form key="qa2" onFinish={handleSubmit} layout="inline" form={form}>
          <Form.Item name="dq">
            <Select allowClear placeholder="工作地点">
              {dqs.map(({ value, label }) => (
                <Option key={value} value={value}>
                  {label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="publishTime">
            <Select allowClear placeholder="发布时间">
              <Option key="0" value="0">
                最近一天
              </Option>
              <Option key="3" value="3">
                最近三天
              </Option>
              <Option key="7" value="7">
                最近七天
              </Option>
            </Select>
          </Form.Item>
          <Form.Item name="deptId">
            <Select allowClear placeholder="部门列表">
              {depts.map(({ value, label }) => (
                <Option key={value} value={value}>
                  {label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="keywords">
            <Input placeholder="关键字" />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" icon={<SearchOutlined />}>
              搜索
            </Button>
          </Form.Item>
        </Form>
        <Table
          key="qa3"
          pagination={{
            current: page.current + 1,
            pageSize,
            total: page.total,
            onChange: handlePageChange,
            showSizeChanger: false,
          }}
          rowKey={(record) => record.id}
          className="_table"
          dataSource={page.dataSource}
          columns={columns}
        />
      </QueueAnim>
    </div>
  );
};

export default JobTable;
